import './index.css';

const SimpleModal = ({ id, children }) => {
  return (
    <div className="modal micromodal-slide" id={id} aria-hidden="true">
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-1-title"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SimpleModal;
